import { useState } from "react";
import { CaretDown, ShieldCheck, LockKey, Fingerprint, Detective, Database, ListMagnifyingGlass, Globe, UsersThree } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

const ITEMS = [
  { icon: LockKey, title: "secEncryption", desc: "secEncryptionDesc" },
  { icon: Fingerprint, title: "secTokens", desc: "secTokensDesc" },
  { icon: Detective, title: "secBruteForce", desc: "secBruteForceDesc" },
  { icon: Globe, title: "secHeaders", desc: "secHeadersDesc" },
  { icon: ListMagnifyingGlass, title: "secAudit", desc: "secAuditDesc" },
  { icon: Database, title: "secBackup", desc: "secBackupDesc" },
  { icon: UsersThree, title: "secRoles", desc: "secRolesDesc" },
];

export default function SecurityInfo() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-6 border-t border-slate-200 pt-4">
      <button
        type="button"
        data-testid="security-info-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 text-left group"
      >
        <span className="flex items-center gap-2">
          <span className="h-7 w-7 rounded-md bg-emerald-50 border border-emerald-200 flex items-center justify-center">
            <ShieldCheck size={16} weight="fill" className="text-emerald-600" />
          </span>
          <span>
            <span className="block text-sm font-semibold text-slate-800">{t("secTitle")}</span>
            <span className="block text-[11px] text-slate-500">{t("secSubtitle")}</span>
          </span>
        </span>
        <CaretDown size={14} weight="bold" className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul data-testid="security-info-list" className="mt-4 space-y-3">
          {ITEMS.map(({ icon: Icon, title, desc }) => (
            <li key={title} className="flex gap-3">
              <Icon size={16} weight="duotone" className="text-blue-900 mt-0.5 shrink-0" />
              <div>
                <p className="text-xs font-semibold text-slate-800">{t(title)}</p>
                <p className="text-[11px] text-slate-500 leading-snug">{t(desc)}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
